<section class="shop__area pb-65" *ngIf="productData">
  <div class="shop__top grey-bg-6 pt-100 pb-90">
    <div class="container">
      <!-- <app-product-details-upper [product]="product!"></app-product-details-upper> -->
      <div class="row">
        <div class='col-xl-6 col-lg-6'>

          <div class="product__modal-box d-flex">
            <div class="product__modal-nav mr-20">
              <nav>
                <div class="nav nav-tabs" id="product-details" role="tablist">
                  <a *ngFor="let img of productData.product_gallery" class="nav-item nav-link mb-1 cursor-pointer"
                    [class.active]="imagePath+img === activeImg">
                    <div class="product__nav-img w-img" (click)="handleImageActive(img)" >
                      <img [src]="imagePath+img" alt="product-img" style="width: 92px;height: 117px;">
                    </div>
                  </a>
                </div>
              </nav>
            </div>
            <div class="mb-20">
              <div class="product__modal-img product__thumb w-img">
                <img [src]="activeImg" alt="product-img">
                <!-- <div *ngIf="product.discount || product.new" class="product__sale">
                  <span *ngIf="product.new || product.discount" class="new">new</span>
                  <span *ngIf="product.discount" class="percent">-{{ product.discount }}%</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class='col-xl-6 col-lg-6'>
          <div class="product__modal-content product__modal-content-2">
            <h4><a [routerLink]="['/shop/product', productData.id]">{{productData.title}}</a></h4>
            <!-- <div class="rating rating-shop mb-15">
              <ul>
                <li><span><i class="fas fa-star"></i></span></li>
                <li><span><i class="fas fa-star"></i></span></li>
                <li><span><i class="fas fa-star"></i></span></li>
                <li><span><i class="fas fa-star"></i></span></li>
                <li><span><i class="fal fa-star"></i></span></li>
              </ul>
              <span class="rating-no ml-10 rating-left">
                {{product.reviews.length}} rating(s)
              </span>
              <span class="review rating-left"><a href="#">Add your Review</a></span>
            </div> -->
            <div class="product__price-2 mb-25">
              <span>₹{{ (productData.sale_price)?productData.sale_price.toFixed(2):productData.regular_price.toFixed(2) }}</span>
              <span *ngIf="productData.sale_price" class="old-price">₹{{productData.regular_price.toFixed(2)}}</span>
            </div>
            <div class="product__modal-des mb-30">
              <p>{{productData.short_description}}</p>
            </div>
            <div class="product__modal-form mb-30">
              <form action="#">
                <div class="pro-quan-area d-sm-flex align-items-center">
                  <div class="product-quantity-title">
                    <label>Quantity</label>
                  </div>
                  <div class="product-quantity mr-20 mb-20">
                    <div class="cart-plus-minus">
                      <input type="text" [value]="cartService.orderQuantity" disabled readonly />
                      <div (click)="cartService.decrement()" class="dec qtybutton">-</div>
                      <div (click)="cartService.increment()" class="inc qtybutton">+</div>
                    </div>
                  </div>
                  <div class="pro-cart-btn">
                    <a (click)="cartService.addCartProduct(productData)" class="add-cart-btn mb-20 cursor-pointer">
                      + Add to Cart
                    </a>
                  </div>
                </div>
              </form>
            </div>

            <div *ngIf="productData.category">
              <div class="product__tag mb-25">
                <span>Category:</span>
                <span><a class="cursor-pointer">{{productData.category.title}}</a></span>
              </div>
              <div class="product__share">
                <span (click)="downloadpdf();">Download</span>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="shop__bottom">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="product__details-tab">
            <div class="product__details-tab-nav text-center mb-45">
              <nav>
                <div class="nav nav-tabs justify-content-start justify-content-sm-center" id="pro-details" role="tablist">
                  <a class="nav-item nav-link active" id="des-tab" data-bs-toggle="tab" href="#des" role="tab" aria-controls="des" aria-selected="true">Description</a>
                  <a class="nav-item nav-link" id="add-tab" data-bs-toggle="tab" href="#add" role="tab"
                    aria-controls="add" aria-selected="false">Additional Information</a>
                  <!-- <a class="nav-item nav-link" id="review-tab" data-bs-toggle="tab" href="#review" role="tab" aria-controls="review" aria-selected="false">Reviews ({{product?.reviews?.length}})</a> -->
                </div>
              </nav>
            </div>
            <div class="tab-content" id="pro-detailsContent">
              <div class="tab-pane fade show active" id="des" role="tabpanel">
                <div class="product__details-des" [innerHtml]="productData.description">
                  <!-- <p>{{product?.details?.details_text}}</p>
                  <div class="product__details-des-list mb-20">
                    <ul>>
                      <li *ngFor="let list of product?.details?.details_list">
                        <span>{{list}}</span>
                      </li>
                    </ul>
                  </div>
                  <p>{{product?.details?.details_text_2}}</p> -->
                </div>
              </div>
              <div class="tab-pane fade" id="add" role="tabpanel">
                <div class="product__details-add">
                  <div *ngFor="let attr of productSpecification | keyvalue">
                    <h4>{{ attr.key }}</h4>
                    <ng-container *ngIf="attr.value">
                      <table class="table table-borderless">
                        <tr *ngFor="let item of attr?.value | keyvalue; index as i">
                          <th style="width: 50%;">{{ item.value['item_title'] }}</th>
                          <td>{{ item.value['item_value'] }}</td>
                        </tr>
                      </table>
                    </ng-container>

                    <!-- <ul *ngFor="let item of attr.value">
                      <li><span>{{ item.item_title }}</span></li>
                      <li><span>{{ item.item_value }}</span></li>
                    </ul> -->
                  </div>
                </div>
              </div>

              <!--<div class="tab-pane fade" id="review" role="tabpanel">
                <div class="product__details-review">
                  <div class="postbox__comments">
                    <div class="postbox__comment-title mb-30">
                      <h3>Reviews ({{product?.reviews?.length}})</h3>
                    </div>
                    <div class="latest-comments mb-30">
                      <ul>
                        <li *ngFor="let r of product?.reviews">
                          <div class="comments-box">
                            <div class="comments-avatar">
                              <img [src]="r.img" alt="user">
                            </div>
                            <div class="comments-text">
                              <div class="avatar-name">
                                <h5>{{r.name}}</h5>
                                <span> - {{r.time}} </span>
                              </div>
                              <div class="user-rating">
                                <ul>
                                  <li><a href="#"><i class="fas fa-star"></i></a></li>
                                  <li><a href="#"><i class="fas fa-star"></i></a></li>
                                  <li><a href="#"><i class="fas fa-star"></i></a></li>
                                  <li><a href="#"><i class="fas fa-star"></i></a></li>
                                  <li><a href="#"><i class="fal fa-star"></i></a></li>
                                </ul>
                              </div>
                              <p>{{r.review_desc}}</p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="post-comments-form mb-100">
                    <div class="post-comments-title mb-30">
                      <h3>Your Review</h3>
                      <div class="post-rating">
                        <span>Your Rating :</span>
                        <ul>
                          <li>
                            <a href="#">
                              <i class="fal fa-star"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i class="fal fa-star"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i class="fal fa-star"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i class="fal fa-star"></i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i class="fal fa-star"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                   <!-- review form start -->
                   <!-- <app-review-form></app-review-form> -->
                   <!-- review form end -->
                  <!-- </div> -->
                <!-- </div> -->
              <!-- </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
